<template>
	<section class="view-venue-communitygallery">
		<header>
			<h5>
				{{ totalItems }} Community
				<span v-if="totalItems === 1">Photo</span>
				<span v-else>Photos</span>
			</h5>
		</header>

		<ChalkyUtilityGallery
			layout="grid"
			sortBy="none"
			v-bind:key="venueModel.taggedMedia.uniqueKey"
			v-bind:mediaSource="venueModel.taggedMedia"
			v-on:select="Handle_OnSelectMediaGalleryItem"
		/>

		<ChalkyUtilityPagination
			class="push-top"
			v-bind:collection="venueModel.taggedMedia"
			v-bind:showNext="false"
			v-bind:showPrevious="false"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueCommunityGallery extends ViewBase {
		/**
		 * @return number
		 */
		protected get totalItems(): number {
			const output = this.venueModel.taggedMedia?.pagination?.total || 0;

			// Ensure cache bust
			this.venueModel.uniqueKey;

			return output;
		}

		/**
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * @return Promise<void>
		 */
		@mounted
		protected async setup(): Promise<void> {
			await this.venueModel.taggedMedia.fetch();
		}

		/**
		 * @param ChalkySticks.Model.Media mediaModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectMediaGalleryItem(mediaModel: ChalkySticks.Model.Media): Promise<void> {
			this.$router.push({
				name: 'PagePlaceGalleryItem',
				params: {
					id: this.venueModel.id,
					mediaId: mediaModel.id,
				},
			});
		}
	}
</script>

<style lang="scss">
	.view-venue-communitygallery {
		header {
			padding: 1rem;
		}

		.utility-gallery.grid {
			grid-template-columns: repeat(auto-fill, minmax(125px, 1fr));

			.gallery-item {
				aspect-ratio: 1 / 1;
			}
		}

		.utility-pagination {
			flex: 0 0 auto !important;
			justify-content: center;
			margin-bottom: 1rem;
		}
	}

	// Variations
	// ---------------------------------------------------------------------------

	.modal-content .view-venue-communitygallery {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
</style>
